<template>
    <li v-if="showEntry">
        <a
            class="flex px-3 py-1 text-sm font-medium"
            href="#0"
            @click.prevent.stop="handleAction"
            ><div>
                <fa
                    :icon="icon"
                    class="mr-2"
                    :class="color"
                />
                <span class="text-gray-600 hover:text-gray-800">{{
                    $t(label)
                }}</span>
            </div></a
        >
    </li>
    <Teleport to="body">
        <WarningModal
            :id="`warning-modal-${label}`"
            :title="$t('warning')"
            :open="warningModalOpen"
            :action-label="$t('warning_modal_text', { actionLabel: $t(label) })"
            @cancel="warningModalOpen = false"
            @continue="onContinue"
        />
    </Teleport>
</template>
<script setup lang="ts">
import WarningModal from './WarningModal.vue'
import { computed, ref } from 'vue'

const props = defineProps<{
    label: string
    icon: string
    color: string
    action: () => void
    condition?: () => boolean
    needsWarning?: boolean
}>()

const showEntry = computed(() => {
    if (typeof props.condition !== 'function') {
        return true
    }
    return props.condition()
})

const warningModalOpen = ref(false)

const handleAction = () => {
    if (props.needsWarning) {
        warningModalOpen.value = true
    } else {
        props.action()
    }
}

const onContinue = () => {
    warningModalOpen.value = false
    props.action()
}
</script>
